import { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { SidebarHeaderContent } from 'src/v2/components/sidebar-header-content'
import { SidebarHeader } from 'src/v2/components/sidebar-header'
import { CoverWithCloseButton } from 'src/components/sidebar-panels/custom-area-info/cover-with-close-button'
import { AvailableInsights } from 'src/components/sidebar-panels/available-insights'
import { PersonalInsights } from 'src/components/sidebar-panels/personal-insights'
import { CustomAreaInfoFacts } from 'src/components/sidebar-panels/custom-area-info'
import { FlexColumn } from 'src/components/flex-containers'
import { UserListsPopover } from 'src/components/user-lists-popover'
import { MapExplorerPanelActions } from 'src/views/map-explorer/sidebar/panels/actions'
import { Shapes } from 'src/components/theme'

import * as coreAtoms from 'src/v2/state/core'
import * as userListsAtoms from 'src/atoms/user-lists'
import * as userListsPopoverAtoms from 'src/atoms/user-lists/user-lists-popover'
import { ErrorBoundary } from 'src/components/errors/error-boundary'

export const MapExplorerSelectedArea = () => {
  const selectedEntity = useAtomValue(coreAtoms.selectedEntity)
  const [userListItem, setUserListItem] = useRecoilState(userListsAtoms.userListItem)
  const setUserListsPopoverAnchorElement = useSetRecoilState(userListsPopoverAtoms.anchorElement)
  const isSaved = useRecoilValue(userListsAtoms.isSaved(userListItem))
  const customAreaName = userListItem && 'name' in userListItem.data ? userListItem.data.name : 'Custom Area'

  const openUserListsPopover = (evt: React.MouseEvent<HTMLElement>) =>
    setUserListsPopoverAnchorElement(evt.currentTarget)

  useEffect(() => {
    if (!selectedEntity || selectedEntity.type !== 'SELECTED_AREA') {
      return
    }
    setUserListItem({
      type: 'custom-area',
      data: {
        name: '',
        description: '',
        ...selectedEntity.data,
      },
    })
  }, [selectedEntity])

  if (!selectedEntity || selectedEntity.type !== 'SELECTED_AREA') {
    return null
  }

  return (
    <>
      <ErrorBoundary wrap>
        <SidebarHeader
          cover={<CoverWithCloseButton />}
          content={
            <SidebarHeaderContent title={customAreaName}>
              <CustomAreaInfoFacts />
            </SidebarHeaderContent>
          }
        />
      </ErrorBoundary>
      <FlexColumn gap={Shapes.spacing[5]}>
        <ErrorBoundary wrap>
          <MapExplorerPanelActions
            save={{
              onClick: openUserListsPopover,
              isSaved,
            }}
            streetView
          />
        </ErrorBoundary>
        <ErrorBoundary wrap>
          <PersonalInsights />
        </ErrorBoundary>
        <ErrorBoundary wrap>
          <AvailableInsights only="area" />
        </ErrorBoundary>
      </FlexColumn>
      <UserListsPopover />
    </>
  )
}
